import * as mmb from 'music-metadata-browser';


function arrayToFile(data, type, name){
  const theBlob = new Blob(data, { type });
  return new File([theBlob], name, {
    type: theBlob.type,
    lastModified: Date.now()
  });
}

function padTo2(value) {
  if (!value) {
    return "00";
  }
  return value < 10 ? String(value).padStart(2, "0") : value;
}
function getHHMMSSFromSeconds(totalSeconds) {
  if (!totalSeconds) {
    return "00:00:00";
  }
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const hhmmss = padTo2(hours) + ":" + padTo2(minutes) + ":" + padTo2(seconds);
  return hhmmss;
}

function groupBy(musics) {
  const list = musics.map((i) => i.album);
  const uniqueList = Array.from(new Set(list));
  const groups = uniqueList.map((c) => {
    return { name: c, tracks: [] };
  });
  musics.forEach((d) => {
    const item = groups.find((g) => g.name === d.album);
    item.tracks.push(d);
    delete d.album;
    if (!item.year) item.year = d.year;
    if (item.year === d.year) delete d.year;
    if (!item.artists) item.artists = d.artists;
    delete d.artists;
    d.duration = getHHMMSSFromSeconds(Math.round(d.duree));
    if (!item.genres) item.genres = d.genres;
    if (JSON.stringify(item.genres) === JSON.stringify(d.genres)) delete d.genres;
  });
  return groups;
}

async function readFile(file, image) {
    const data = await  mmb.parseBlob(file, { duration: true });
    const metadata = data.common;
    if (metadata) {
        const music = {
            file: file,
            title: metadata.title,
            artists: metadata.artists,
            album: metadata.album,
            genres: metadata.genre,
            track: metadata.track.no,
            year: metadata.year,
            duree: data.format.duration,
            duration: "",
            bitrate: data.format.bitrate,
            sampleRate: data.format.sampleRate
        };

        //console.log(metadata)
        if (metadata.picture && metadata.picture.length > 0 && metadata.picture[0].data) {
          if (image.data === null) {
            image.name = `${metadata.artists}_${metadata.album}.${metadata.picture[0].format.replace(/image\//g, '')}`;
            image.data = metadata.picture[0].data;
            image.file = arrayToFile(metadata.picture[0].data, metadata.picture[0].format, image.name);
          }
        }
        return music;
    }

}

export default async (files) => {
  const musics = []
  const image = {
    data: null,
    name: null
  }
  files.forEach(file => {
    if (file.type === 'audio/mpeg') musics.push(readFile(file, image));
  })
  const result = await Promise.all(musics);

  const album = groupBy(result)[0];
  if (album) album.image = image;
  
  return album;
}